export const TEMPERATURE_REQUEST_ATTRIBUTES = [
    'driver_ids',
    'interval_desc',
    'result_from',
    'result_to',
    'average_ambient_temperature',
    'vehicle_ids',
];
